import React, { useState, useEffect, useContext} from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import Menu from "../include/menu";
import Footer from "../include/footer";
import Modal from 'react-modal';
import Swal  from "sweetalert2";
import AOS from "aos";
import "aos/dist/aos.css";
import Context from "../../../context/context";
import Web3 from "web3";
import { providerURL, formatDateAndtime, txAfterDone, txDone, txStart} from "../utils";
import UFOpTGCContract from '../abi/pTGC.json';
import UFOHEXContract from '../abi/HEX.json';
import UFOHEXETHContract from '../abi/HEXETH.json';
import UFOINCContract from '../abi/INC.json';
import UFOPLSXContract from '../abi/PLSX.json';
import UFOPLSContract from '../abi/PLS.json';
import UFODAIContract from '../abi/DAI.json';
import UFOContract from '../abi/UFO.json';
import StakingContract from '../abi/Staking.json';
import { formatUnits } from "ethers";

const IndexSections = () => {
  const {account, onConnect, providers} = useContext(Context);
  const [copyaddress, setCopyaddress] = useState('00');
  const [mymodalIsOpen, setIsOpen] = React.useState(false);
  const [refresh, setRefresh] = useState(false);
  const [UFOpTGC, setUFOpTGC] = useState({balance:0, staked:0, pending:0, ufo:0, address:0});
  const [UFOHEX, setUFOHEX] = useState({balance:0, staked:0, pending:0, ufo:0, address:0});
  const [UFOHEXETH, setUFOHEXETH] = useState({balance:0, staked:0, pending:0, ufo:0, address:0});
  const [UFOINC, setUFOINC] = useState({balance:0, staked:0, pending:0, ufo:0, address:0});
  const [UFOPLSX, setUFOPLSX] = useState({balance:0, staked:0, pending:0, ufo:0, address:0});
  const [UFOPLS, setUFOPLS] = useState({balance:0, staked:0, pending:0, ufo:0, address:0});
  const [UFODAI, setUFODAI] = useState({balance:0, staked:0, pending:0, ufo:0, address:0});
  const [pendingReward, setPendingReward] = useState(0);
  const [earnedFromReflection, setEarnedFromReflection] = useState(0);
  const [earnedFromReward, setEarnedFromReward] = useState(0);

  useEffect(() => {
    getData()
  }, [refresh, account]);

  const getData = async () => {
      const web3 = new Web3(providerURL());

      const UFOpTGCInstance = new web3.eth.Contract(UFOpTGCContract.ABI, UFOpTGCContract.Contract);
      const UFOHEXInstance = new web3.eth.Contract(UFOHEXContract.ABI, UFOHEXContract.Contract);
      const UFOHEXETHInstance = new web3.eth.Contract(UFOHEXETHContract.ABI, UFOHEXETHContract.Contract);
      const UFOINCInstance = new web3.eth.Contract(UFOINCContract.ABI, UFOINCContract.Contract);
      const UFOPLSXInstance = new web3.eth.Contract(UFOPLSXContract.ABI, UFOPLSXContract.Contract);
      const UFOPLSInstance = new web3.eth.Contract(UFOPLSContract.ABI, UFOPLSContract.Contract);
      const UFODAIInstance = new web3.eth.Contract(UFODAIContract.ABI, UFODAIContract.Contract);
      const StakingInstance = new web3.eth.Contract(StakingContract.ABI, StakingContract.Contract);
      const UFOInstance = new web3.eth.Contract(UFOContract.ABI, UFOContract.Contract);

      if(account)
      {
          let pendingAll = 0;
          let UFOpTGCBalance = Number(formatUnits(await UFOpTGCInstance.methods.balanceOf(account).call(), 18));
          let UFOHEXBalance = Number(formatUnits(await UFOHEXInstance.methods.balanceOf(account).call(), 18));
          let UFOHEXETHBalance = Number(formatUnits(await UFOHEXETHInstance.methods.balanceOf(account).call(), 18));
          let UFOINCBalance = Number(formatUnits(await UFOINCInstance.methods.balanceOf(account).call(), 18));
          let UFOPLSXBalance = Number(formatUnits(await UFOPLSXInstance.methods.balanceOf(account).call(), 18));
          let UFOPLSBalance = Number(formatUnits(await UFOPLSInstance.methods.balanceOf(account).call(), 18));
          let UFODAIBalance = Number(formatUnits(await UFODAIInstance.methods.balanceOf(account).call(), 18));

          let UFOpTGCInfo = await StakingInstance.methods.stakingInfo(account, UFOpTGCContract.Contract).call();
          let UFOHEXInfo = await StakingInstance.methods.stakingInfo(account, UFOHEXContract.Contract).call();
          let UFOHEXETHInfo = await StakingInstance.methods.stakingInfo(account, UFOHEXETHContract.Contract).call();
          let UFOINCInfo = await StakingInstance.methods.stakingInfo(account, UFOINCContract.Contract).call();
          let UFOPLSXInfo = await StakingInstance.methods.stakingInfo(account, UFOPLSXContract.Contract).call();
          let UFOPLSInfo = await StakingInstance.methods.stakingInfo(account, UFOPLSContract.Contract).call();
          let UFODAIInfo = await StakingInstance.methods.stakingInfo(account, UFODAIContract.Contract).call();

          let UFOpTGCPending = Number(formatUnits(await StakingInstance.methods.pendingReward(account, UFOpTGCContract.Contract).call(), 18));;
          let UFOHEXPending = Number(formatUnits(await StakingInstance.methods.pendingReward(account, UFOHEXContract.Contract).call(), 18));
          let UFOHEXETHPending = Number(formatUnits(await StakingInstance.methods.pendingReward(account, UFOHEXETHContract.Contract).call(), 18));
          let UFOINCPending = Number(formatUnits(await StakingInstance.methods.pendingReward(account, UFOINCContract.Contract).call(), 18)); 
          let UFOPLSXPending = Number(formatUnits(await StakingInstance.methods.pendingReward(account, UFOPLSXContract.Contract).call(), 18));
          let UFOPLSPending = Number(formatUnits(await StakingInstance.methods.pendingReward(account, UFOPLSContract.Contract).call(), 18));
          let UFODAIPending = Number(formatUnits(await StakingInstance.methods.pendingReward(account, UFODAIContract.Contract).call(), 18));

          const newUFOpTGC = { ...UFOpTGC };
                newUFOpTGC.balance = UFOpTGCBalance;
                newUFOpTGC.address = UFOpTGCContract.Contract;
                newUFOpTGC.staked = Number(formatUnits(UFOpTGCInfo.stakedLP , 18));
                newUFOpTGC.ufo = Number(formatUnits(UFOpTGCInfo.stakedUFO, 18));
                newUFOpTGC.pending = Number(formatUnits(UFOpTGCInfo.pendingReward, 18)) + UFOpTGCPending;
                setUFOpTGC(newUFOpTGC);

          const newUFOHEX = { ...UFOHEX };
                newUFOHEX.balance = UFOHEXBalance;
                newUFOHEX.address = UFOHEXContract.Contract;
                newUFOHEX.staked = Number(formatUnits(UFOHEXInfo.stakedLP, 18));
                newUFOHEX.ufo = Number(formatUnits(UFOHEXInfo.stakedUFO, 18));
                newUFOHEX.pending = Number(formatUnits(UFOHEXInfo.pendingReward, 18)) + UFOHEXPending;
                setUFOHEX(newUFOHEX);

          const newUFOHEXETH = { ...UFOHEXETH };
                newUFOHEXETH.balance = UFOHEXETHBalance;
                newUFOHEXETH.address = UFOHEXETHContract.Contract;
                newUFOHEXETH.staked = Number(formatUnits(UFOHEXETHInfo.stakedLP, 18));
                newUFOHEXETH.ufo = Number(formatUnits(UFOHEXETHInfo.stakedUFO, 18));
                newUFOHEXETH.pending = Number(formatUnits(UFOHEXETHInfo.pendingReward, 18)) + UFOHEXETHPending;
                setUFOHEXETH(newUFOHEXETH);

           const newUFOINC = { ...UFOINC };
                 newUFOINC.balance = UFOINCBalance;
                 newUFOINC.address = UFOINCContract.Contract;
                 newUFOINC.staked = Number(formatUnits(UFOINCInfo.stakedLP, 18));
                 newUFOINC.ufo = Number(formatUnits(UFOINCInfo.stakedUFO, 18));
                 newUFOINC.pending = Number(formatUnits(UFOINCInfo.pendingReward, 18)) + UFOINCPending;
                 setUFOINC(newUFOINC);

           const newUFOPLSX = { ...UFOPLSX };
                 newUFOPLSX.balance = UFOPLSXBalance;
                 newUFOPLSX.address = UFOPLSXContract.Contract;
                 newUFOPLSX.staked = Number(formatUnits(UFOPLSXInfo.stakedLP, 18));
                 newUFOPLSX.ufo = Number(formatUnits(UFOPLSXInfo.stakedUFO, 18));
                 newUFOPLSX.pending = Number(formatUnits(UFOPLSXInfo.pendingReward, 18)) + UFOPLSXPending;
                 setUFOPLSX(newUFOPLSX);

           const newUFOPLS = { ...UFOPLS };
                 newUFOPLS.balance = UFOPLSBalance;
                 newUFOPLS.address = UFOPLSContract.Contract;
                 newUFOPLS.staked = Number(formatUnits(UFOPLSInfo.stakedLP, 18));
                 newUFOPLS.ufo = Number(formatUnits(UFOPLSInfo.stakedUFO, 18));
                 newUFOPLS.pending = Number(formatUnits(UFOPLSInfo.pendingReward, 18)) + UFOPLSPending;
                 setUFOPLS(newUFOPLS);

            const newUFODAI = { ...UFODAI };
                  newUFODAI.balance = UFODAIBalance;
                  newUFODAI.address = UFODAIContract.Contract;
                  newUFODAI.staked = Number(formatUnits(UFODAIInfo.stakedLP, 18));
                  newUFODAI.ufo = Number(formatUnits(UFODAIInfo.stakedUFO, 18));
                  newUFODAI.pending = Number(formatUnits(UFODAIInfo.pendingReward, 18)) + UFODAIPending;
                  setUFODAI(newUFODAI);
            pendingAll = newUFOpTGC.pending + newUFOHEX.pending + newUFOHEXETH.pending + newUFOINC.pending + newUFOPLSX.pending + newUFOPLS.pending + newUFODAI.pending;
            setPendingReward(pendingAll);

            let receivedUFO = Number(formatUnits(await UFOInstance.methods.totalReceived(account).call(), 18));
            let sendUFO = Number(formatUnits(await UFOInstance.methods.totalSend(account).call(), 18));
            let balanceUFO = Number(formatUnits(await UFOInstance.methods.balanceOf(account).call(), 18));
            var reflectionReward = parseInt(0);
            if((receivedUFO + balanceUFO) > sendUFO) 
            {
              reflectionReward = (sendUFO + balanceUFO) - receivedUFO; 
            }
            setEarnedFromReflection(reflectionReward);
            setEarnedFromReward(Number(formatUnits(await StakingInstance.methods.claimedReward(account).call(), 18)));
      }
  }

  const claimRewards = async () => {
      const web3 = new Web3(providers);
      const stakingContract = new web3.eth.Contract(StakingContract.ABI, StakingContract.Contract);
      try {
          Swal.fire({
            title: "Sure you want to claim PLS reward?",
            icon: "warning",
            buttons: [
                'No, cancel it!',
                'Yes, I am sure!'
            ],
            dangerMode: true,
          }).then(async (willDelete) => {
              if (willDelete) {
                await stakingContract.methods.claimRewards().send({
                    from: account
                }).on('transactionHash', function(payload) {
                    txStart();
                }).on('error', function(error) {
                    Swal.fire({
                      title: "Error Found",
                      text: error.message,
                      icon: "error",
                      showCancelButton: false,
                      confirmButtonText: "Close",
                      customClass: {
                        confirmButton: "btn-danger"
                      }
                    });
                }).then(function(receipt) {
                    txDone()
                    setTimeout(() => {
                        txAfterDone()
                    }, 2000)
                    setRefresh(!refresh)
                });
              }
          });
      } catch (error) {
        Swal.fire({
          title: "Error Found",
          text: error.message,
          icon: "error",
          showCancelButton: false,
          confirmButtonText: "Close",
          customClass: {
            confirmButton: "btn-danger"
          }
        });
      }
  };

  const claimReward = async (address) => {
      const web3 = new Web3(providers);
      const stakingContract = new web3.eth.Contract(StakingContract.ABI, StakingContract.Contract);
      try {
          Swal.fire({
            title: "Sure you want to claim PLS reward?",
            icon: "warning",
            buttons: [
                'No, cancel it!',
                'Yes, I am sure!'
            ],
            dangerMode: true,
          }).then(async (willDelete) => {
              if (willDelete) {
                  await stakingContract.methods.claimReward(address).send({
                      from: account
                  }).on('transactionHash', function(payload) {
                      txStart();
                  }).on('error', function(error) {
                      Swal.fire({
                        title: "Error Found",
                        text: error.message,
                        icon: "error",
                        showCancelButton: false,
                        confirmButtonText: "Close",
                        customClass: {
                          confirmButton: "btn-danger"
                        }
                      });
                  }).then(function(receipt) {
                      txDone()
                      setTimeout(() => {
                          txAfterDone()
                      }, 2000)
                      setRefresh(!refresh)
                  });
              }
          });
      } catch (error) {
        Swal.fire({
          title: "Error Found",
          text: error.message,
          icon: "error",
          showCancelButton: false,
          confirmButtonText: "Close",
          customClass: {
            confirmButton: "btn-danger"
          }
        });
      }
  };

  function myCopy(e) {
      navigator.clipboard.writeText(e.currentTarget.title);
      setIsOpen(true);
      setCopyaddress(" " + e.currentTarget.title);
      setTimeout(() => {
        setIsOpen(false);
      }, 2000);
  }

  function mycloseModal() {
    setIsOpen(false);
  }

  useEffect(() => {
    AOS.init({
      duration: 1000, 
      once: true, 
    });
  }, []);

  return (
  <>
  <Menu />
  <section className="UFOSEC slideSec slideSecInner leftrightSecSpace">
    <div className="1 relative">
      <div className="row justify-content-between">
        <div className="col-xl-7">
          <div className="sliderContent">
            <h1 className='good_times goldFont'  data-aos="fade-up"  data-aos-delay="300" data-aos-duration="600"><img src="./images/ufo_logoName.svg" className="img-fluid logoNameInnerPage m-0 d-inline-block"/> Rewards</h1>
            <p className='mt-0' data-aos="fade"  data-aos-delay="500" data-aos-duration="800">Earn passive income  with UFO rewards.</p>
            <div className="bottomSliderBtn"  data-aos="fade-right"  data-aos-delay="700" data-aos-duration="1000">
              <div className="d-flex gap-3 align-items-center">
                <button className="borderbtn mybtn" disabled={account ? 'disabled' :''} onClick={onConnect}>
                  <span>Connect Wallet</span> <img src="./images/circle_arrow.svg" className="img-fluid" />
                </button>
                <a href="https://scan.pulsechain.com/address/0x5958b1f2113a81EE68b65C0c7102425D41b53bfd" target="_blank" className="mybtn underline text-white"><span>View Reward Contract</span></a>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-5 slR">
          <div className="bottomSliderRight " data-aos="fade-left"  data-aos-delay="700" data-aos-duration="1000">
            <div className="bSRIN overHide">
              <div className="snPortal border0">
                <div className="SRTOP d-flex flex-wrap gap-2 justify-content-between align-items-center ">
                  <div className="d-flex flex-wrap gap-2 align-items-center ">
                    <div className="iconSR "><img src="./images/ptgc/ufologo_circle.svg" className="img-fluid" /></div>
                    <span className="fInter goldFont">UFO Token Address</span>
                  </div>
                  <button className="iconSR" onClick={myCopy} title={UFOContract.Contract}><i className="fa-solid fa-copy"></i></button>
                </div>
                <div className="inputBGCOin d-flex justify-content-between align-items-center gap-3 w-100 mt-3">
                  <p className="wordbreak w-100 f16 m-0 val p-2 px-3">{UFOContract.Contract}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className='UFORewardsSec UFOSEC clippathSec padsec ProposalSec stakeSec StatsSec leftrightSecSpace'> 
    <div className="d-flex justify-content-between align-items-center">
      <div>
      <h2 className="good_times goldFont">Manage Rewards</h2>
      <p>Notice: If you don’t claim your rewards and you close the LP down, You lose your PLS rewards.</p>
      </div>
    </div>
    <div className="statsALL">
      <div className="row">
        <div className="col-sm-12">
          <div className="subcontent  SRTOP p-0">
            <div className="row align-items-center">
              <div className="col-md-6 col-xl-2 w-20 bordercol borderRight">
                <div className=" snstakes " style={{borderBottom:'0px'}}>
                  <div className="relative d-flex align-items-center">
                    <img className=" " alt="" src="./images/ufo.svg" />   
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-2 w-20 bordercol borderRight">
                <div className=" snstakes " style={{borderBottom:'0px'}}>
                  <div className="relative ">
                    <div className="mt-0">
                      <span className="perVal d-block">Earned From Reflection</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(earnedFromReflection).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">UFO</span>
                      </h3>
                    </div>    
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-2 w-20 bordercol mobBorderTopAdd767 borderRight">
                <div className=" snstakes " style={{borderBottom:'0px'}}>
                  <div className="relative ">
                    <div className="mt-0">
                      <span className="perVal d-block">Earned From Reward</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(earnedFromReward).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">PLS</span>
                      </h3>
                    </div>    
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-2 w-20 bordercol mobBorderTopAdd767 borderRight">
                <div className=" snstakes " style={{borderBottom:'0px'}}>
                  <div className="relative ">
                    <div className="mt-0">
                      <span className="perVal d-block">Pending To Claim</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(pendingReward).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">PLS</span>
                      </h3>
                    </div>    
                  </div>
                </div>
              </div>
              <div className="col-md-12 mobBorderTopAdd1191 col-xl-2 w-20 bordercol">
                <div className=" snstakes " style={{borderBottom:'0px'}}>
                  <div className="relative ">    
                    <button className="mb_down1 borderbtn mybtn  d-flex justify-content-between w-100 align-items-center" disabled={pendingReward > 0 ? '' :'disabled'} onClick={()=>{ claimRewards()}}>
                      <span className="d-flex justify-content-between w-100 align-items-center">Claim Reward <img className="img-fluid" src="./images/circle_arrow.svg"/></span>
                    </button>
                  </div> 
                </div>
              </div>
            </div>
          </div>
          <div className="statsALL RewardsALL">
          <div className="row">
           <div className="col-sm-6">
            <div className=" subcontent mb-3">
              <div className="snstakes">
                <div className="row align-items-center flex-wrap">
                  <div className="col-sm-12  mb-2">
                    <h2 className="d-flex align-items-center gap-2">
                      <span className="d-flex bothCoins">
                        <img className="img-fluid" src="./images/ptgc/ufologo_circle.svg" />
                        <img className="img-fluid" src="./images/ptgccircle.svg" />
                      </span><span>UFO / PTGC<br/>
                      <span className="perVal d-block mt-2">Earn PLS</span></span>
                    </h2>
                  </div>
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">Total Held</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFOpTGC.balance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">PLP</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">Total Staked</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFOpTGC.staked).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">PLP</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">UFO Shares</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFOpTGC.ufo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">UFO</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">Pending Reward</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFOpTGC.pending).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">PLS</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-12 mt-2 ">
                    <button className="mb_down1 borderbtn mybtn  d-flex justify-content-between align-items-center w-100" disabled={UFOpTGC.pending > 0 ? '' :'disabled'} onClick={()=>{ claimReward(UFOpTGC.address)}}>
                      <span className="d-flex justify-content-between w-100 align-items-center">Claim Reward <img className="img-fluid" src="./images/circle_arrow.svg" /></span>
                    </button>
                  </div> 
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-6">
            <div className=" subcontent mb-3">
              <div className="snstakes">
                <div className="row align-items-center flex-wrap">
                  <div className="col-sm-12  mb-2">
                    <h2 className="d-flex align-items-center gap-2">
                      <span className="d-flex bothCoins">
                        <img className="img-fluid" src="./images/ptgc/ufologo_circle.svg" />
                        <img className="img-fluid" src="./images/HEX.png" />
                      </span><span>UFO / HEX<br/>
                      <span className="perVal d-block mt-2">Earn PLS</span></span>
                    </h2>
                  </div>
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">Total Held</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFOHEX.balance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">PLP</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">Total Staked</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFOHEX.staked).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">PLP</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">UFO Shares</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFOHEX.ufo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">UFO</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">Pending Reward</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFOHEX.pending).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">PLS</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-12 mt-2 ">
                    <button className="mb_down1 borderbtn mybtn  d-flex justify-content-between align-items-center w-100" disabled={UFOHEX.pending > 0 ? '' :'disabled'} onClick={()=>{ claimReward(UFOHEX.address)}}>
                      <span className="d-flex justify-content-between w-100 align-items-center">Claim Reward <img className="img-fluid" src="./images/circle_arrow.svg" /></span>
                    </button>
                  </div> 
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-6">
            <div className=" subcontent mb-3">
              <div className="snstakes">
                <div className="row align-items-center flex-wrap">
                  <div className="col-sm-12  mb-2">
                    <h2 className="d-flex align-items-center gap-2">
                      <span className="d-flex bothCoins">
                        <img className="img-fluid" src="./images/ptgc/ufologo_circle.svg" />
                        <img className="img-fluid" src="./images/HEXETH.png" />
                      </span><span>UFO / HEX<br/>
                      <span className="perVal d-block mt-2">Earn PLS</span></span>
                    </h2>
                  </div>
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">Total Held</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFOHEXETH.balance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">PLP</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">Total Staked</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFOHEXETH.staked).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">PLP</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">UFO Shares</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFOHEXETH.ufo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">UFO</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">Pending Reward</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFOHEXETH.pending).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">PLS</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-12 mt-2 ">
                    <button className="mb_down1 borderbtn mybtn  d-flex justify-content-between align-items-center w-100" disabled={UFOHEXETH.pending > 0 ? '' :'disabled'} onClick={()=>{ claimReward(UFOHEXETH.address)}}>
                      <span className="d-flex justify-content-between w-100 align-items-center">Claim Reward <img className="img-fluid" src="./images/circle_arrow.svg" /></span>
                    </button>
                  </div> 
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-6">
            <div className=" subcontent mb-3">
              <div className="snstakes">
                <div className="row align-items-center flex-wrap">
                  <div className="col-sm-12  mb-2">
                    <h2 className="d-flex align-items-center gap-2">
                      <span className="d-flex bothCoins">
                        <img className="img-fluid" src="./images/ptgc/ufologo_circle.svg" />
                        <img className="img-fluid" src="./images/INC.png" />
                      </span><span>UFO / INC<br/>
                      <span className="perVal d-block mt-2">Earn PLS</span></span>
                    </h2>
                  </div>
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">Total Held</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFOINC.balance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">PLP</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">Total Staked</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFOINC.staked).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">PLP</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">UFO Shares</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFOINC.ufo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">UFO</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">Pending Reward</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFOINC.pending).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">PLS</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-12 mt-2 ">
                    <button className="mb_down1 borderbtn mybtn  d-flex justify-content-between align-items-center w-100" disabled={UFOINC.pending > 0 ? '' :'disabled'} onClick={()=>{ claimReward(UFOINC.address)}}>
                      <span className="d-flex justify-content-between w-100 align-items-center">Claim Reward <img className="img-fluid" src="./images/circle_arrow.svg" /></span>
                    </button>
                  </div> 
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-6">
            <div className=" subcontent mb-3">
              <div className="snstakes">
                <div className="row align-items-center flex-wrap">
                  <div className="col-sm-12  mb-2">
                    <h2 className="d-flex align-items-center gap-2">
                      <span className="d-flex bothCoins">
                        <img className="img-fluid" src="./images/ptgc/ufologo_circle.svg" />
                        <img className="img-fluid" src="./images/PLS.png" />
                      </span><span>UFO / PLS<br/>
                      <span className="perVal d-block mt-2">Earn PLS</span></span>
                    </h2>
                  </div>
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">Total Held</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFOPLS.balance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">PLP</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">Total Staked</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFOPLS.staked).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">PLP</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">UFO Shares</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFOPLS.ufo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">UFO</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">Pending Reward</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFOPLS.pending).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">PLS</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-12 mt-2 ">
                    <button className="mb_down1 borderbtn mybtn  d-flex justify-content-between align-items-center w-100" disabled={UFOPLS.pending > 0 ? '' :'disabled'} onClick={()=>{ claimReward(UFOPLS.address)}}>
                      <span className="d-flex justify-content-between w-100 align-items-center">Claim Reward <img className="img-fluid" src="./images/circle_arrow.svg" /></span>
                    </button>
                  </div> 
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-6">
            <div className=" subcontent mb-3">
              <div className="snstakes">
                <div className="row align-items-center flex-wrap">
                  <div className="col-sm-12  mb-2">
                    <h2 className="d-flex align-items-center gap-2">
                      <span className="d-flex bothCoins">
                        <img className="img-fluid" src="./images/ptgc/ufologo_circle.svg" />
                        <img className="img-fluid" src="./images/PLSX.png" />
                      </span><span>UFO / PLSX<br/>
                      <span className="perVal d-block mt-2">Earn PLS</span></span>
                    </h2>
                  </div>
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">Total Held</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFOPLSX.balance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">PLP</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">Total Staked</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFOPLSX.staked).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">PLP</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">UFO Shares</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFOPLSX.ufo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">UFO</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">Pending Reward</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFOPLSX.pending).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">PLS</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-12 mt-2 ">
                    <button className="mb_down1 borderbtn mybtn d-flex justify-content-between align-items-center w-100" disabled={UFOPLSX.pending > 0 ? '' :'disabled'} onClick={()=>{ claimReward(UFOPLSX.address)}}>
                      <span className="d-flex justify-content-between w-100 align-items-center">Claim Reward <img className="img-fluid" src="./images/circle_arrow.svg" /></span>
                    </button>
                  </div> 
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-6">
            <div className=" subcontent mb-3">
              <div className="snstakes">
                <div className="row align-items-center flex-wrap">
                  <div className="col-sm-12  mb-2">
                    <h2 className="d-flex align-items-center gap-2">
                      <span className="d-flex bothCoins">
                        <img className="img-fluid" src="./images/ptgc/ufologo_circle.svg" />
                        <img className="img-fluid" src="./images/DAI.png" />
                      </span><span>UFO / DAI<br/>
                      <span className="perVal d-block mt-2">Earn PLS</span></span>
                    </h2>
                  </div>
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">Total Held</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFODAI.balance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">PLP</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">Total Staked</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFODAI.staked).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">PLP</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">UFO Shares</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFODAI.ufo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">UFO</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-6 ">
                    <div className="mt-0">
                      <span className="perVal d-block">Pending Reward</span>
                      <h3 className="dollorValue value w-100 mt-0">
                        <span className="val">{parseFloat(UFODAI.pending).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor dollor2">PLS</span>
                      </h3>
                    </div>
                  </div> 
                  <div className="col-sm-12 mt-2 ">
                    <button className="mb_down1 borderbtn mybtn d-flex justify-content-between align-items-center w-100" disabled={UFODAI.pending > 0 ? '' :'disabled'} onClick={()=>{ claimReward(UFODAI.address)}}>
                      <span className="d-flex justify-content-between w-100 align-items-center">Claim Reward <img className="img-fluid" src="./images/circle_arrow.svg" /></span>
                    </button>
                  </div> 
                </div>
              </div>
            </div>
          </div>
         </div>
        </div>
        </div>
      </div>
    </div>
  </section>

  <Modal isOpen={mymodalIsOpen} onRequestClose={mycloseModal}>
    <div className="bottomModal" style={{paddingBottom:'30px'}}>
    <div className=" popupcenter text-center">
      <div className="d-flex justify-content-end">
        <button className="nobg closepopup d-flex align-items-center gap-1" onClick={mycloseModal}  style={{paddingBottom:'0px'}}><span className="underline">Close</span><img className="img-fluid" alt="close" src="./images/XCircle.svg" /></button>
      </div>
      <div className='edittext mb-2'> 
        <h4 className="mb-1 Bold">Copied Address:</h4>
        <div className="dollorVal dollorValRight w-100 mt-0">
          <p className="wordbreak w-100 mt-3 val f34">{copyaddress}</p>
        </div>
      </div>
    </div>
  </div>
  </Modal>
  <Footer />
  </>
  );
};

export default IndexSections;